import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  DxButtonModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxFormModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTextAreaModule,
  DxTextBoxModule,
} from 'devextreme-angular';
import { DeklaracijeComponent } from './pages/deklaracije/deklaracije.component';
import { DjelatniciComponent } from './pages/djelatnici/djelatnici.component';
import { djelatnikPravaComponent } from './pages/djelatnici/djelatnikPrava.component';
import { DnevniPlanComponent } from './pages/dnevni-plan/dnevni-plan.component';
import { DokumentiComponent } from './pages/dokumenti/dokumenti.component';
import { DostavnicaHladComponent } from './pages/dostavnica-hlad/dostavnica-hlad.component';
import { DostavnicaComponent } from './pages/dostavnica/dostavnica.component';
import { IspisPlanaComponent } from './pages/ispis-plana/ispis-plana.component';
import { IzdatniceSirovinaComponent } from './pages/izdatnice-sirovina/izdatnice-sirovina.component';
import { IzvjestajZavrsenihRnComponent } from './pages/izvjestaj-zavrsenih-rn/izvjestaj-zavrsenih-rn.component';
import { RadniNaloziDokumentiComponent } from './pages/radni-nalozi-dokumenti/radni-nalozi-dokumenti.component';
import { KapacitetLinijaComponent } from './pages/kapacitet-linija/kapacitet-linija.component';
import { LotNaljepniceComponent } from './pages/lot-naljepnice/lot-naljepnice.component';
import { NadzornaPlocaComponent } from './pages/nadzorna-ploca/nadzorna-ploca.component';
import { NaruceneKolicineGrupeComponent } from './pages/narucene-kolicine-grupe/narucene-kolicine-grupe.component';
import { NaruceneKolicineComponent } from './pages/narucene-kolicine/narucene-kolicine.component';
import { NarudzbeComponent } from './pages/narudzbe/narudzbe.component';
import { OstvareniSatiComponent } from './pages/ostvareni-sati/ostvareni-sati.component';
import { OtpremnicaComponent } from './pages/otpremnica/otpremnica.component';
import { PartneriComponent } from './pages/partneri/partneri.component';
import { PlanProizvodnjeComponent } from './pages/plan-proizvodnje/plan-proizvodnje.component';
import { PlanskaKalkulacijaComponent } from './pages/planska-kalkulacija/planska-kalkulacija.component';
import { PregledIzdatniceComponent } from './pages/pregled-izdatnice/pregled-izdatnice.component';
import { PregledIzdatniceTrosakComponent } from './pages/pregled-izdatnice-trosak/pregled-izdatnice-trosak.component';
import { PregledIzdatnicePotrosnogMaterijalaComponent } from './pages/pregled-izdatnice-potrosnog-materijala/pregled-izdatnice-potrosnog-materijala.component';
import { PregledLotoviComponent } from './pages/pregled-lotovi/pregled-lotovi.component';
import { PrimkeComponent } from './pages/primke/primke.component';
import { ProcesiComponent } from './pages/procesi/procesi.component';
import { ProizvodiAkcijaComponent } from './pages/proizvodi-akcija/proizvodi-akcija.component';
import { RasporedLjudiComponent } from './pages/raspored-ljudi/raspored-ljudi.component';
import { RokovitrajanjaComponent } from './pages/rokovitrajanja/rokovitrajanja.component';
import { SifarnikProcesiComponent } from './pages/sifarnik-procesi/sifarnik-procesi.component';
import { SifarnikProizvodiComponent } from './pages/sifarnik-proizvodi/sifarnik-proizvodi.component';
import { SignalniLagerComponent } from './pages/signalnilager/signalnilager.component';
import { SkladisteHladComponent } from './pages/skladiste-hlad/skladiste-hlad.component';
import { SkladisteComponent } from './pages/skladiste/skladiste.component';
//new
import { StanjeSkladistaComponent } from './pages/stanje-skladista/stanje-skladista.component';
import { StrojeviComponent } from './pages/strojevi/strojevi.component';
import { UlazSirovinaComponent } from './pages/ulaz-sirovina/ulaz-sirovina.component';
import { UredjajiComponent } from './pages/uredjaji/uredjaji.component';
import { WebappComponent } from './pages/webapp/webapp.component';
import { ZahtjeviZaSirovineComponent } from './pages/zahtjevi-za-sirovine/zahtjevi-za-sirovine.component';
import { LoginFormComponent } from './shared/components';
import { AuthGuardService } from './shared/services';
import { UfeComponent } from './pages/UFA/ufe/ufe.component';
import { UfaComponent } from './pages/UFA/ufa/ufa.component';
import { DigitalnaPlocaComponent } from './pages/digitalna-ploca/digitalna-ploca.component';
import { PregledReversComponent } from './pages/pregled-revers/pregled-revers.component';
import { MeduskladisnicaComponent } from './pages/meduskladisnica/meduskladisnica.component';
import { MeduskladisnicaMrviceComponent } from './pages/meduskladisnica-mrvice/meduskladisnica-mrvice.component';
import { KarticaArtiklaComponent } from './pages/kartica_artikla/kartica_artikla.component';

const routes: Routes = [
  {
    path: 'nadzorna-ploca',
    component: NadzornaPlocaComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'login-form',
    component: LoginFormComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'plan-proizvodnje',
    component: PlanProizvodnjeComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'kapacitet-linija',
    component: KapacitetLinijaComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'narucene-kolicine',
    component: NaruceneKolicineComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'ulaz-sirovina',
    component: UlazSirovinaComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'partneri',
    component: PartneriComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'dnevni-plan',
    component: DnevniPlanComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'izdatnice-sirovina',
    component: IzdatniceSirovinaComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'skladiste',
    component: SkladisteComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'stanje-skladista',
    component: StanjeSkladistaComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'naljepnice',
    component: DeklaracijeComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'pregled-lotovi',
    component: PregledLotoviComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'dostavnica-hlad',
    component: DostavnicaHladComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'skladiste-hlad',
    component: SkladisteHladComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'raspored-ljudi',
    component: RasporedLjudiComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'planska-kalkulacija',
    component: PlanskaKalkulacijaComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'planska-kalkulacija/:id',
    component: PlanskaKalkulacijaComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'procesi',
    component: ProcesiComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'strojevi',
    component: StrojeviComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'sifarnik-procesi',
    component: SifarnikProcesiComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'sifarnik-proizvodi',
    component: SifarnikProizvodiComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'proizvodi-akcija',
    component: ProizvodiAkcijaComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'djelatnici',
    component: DjelatniciComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'djelatnikPrava',
    component: djelatnikPravaComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'izvjestaj-zavrsenih-rn',
    component: IzvjestajZavrsenihRnComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'radni-nalozi-dokumenti',
    component: RadniNaloziDokumentiComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'pregled-zahtjeva-za-sirovine',
    component: ZahtjeviZaSirovineComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'pregled-izdatnice',
    component: PregledIzdatniceComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'pregled-izdatnice-trosak',
    component: PregledIzdatniceTrosakComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'pregled-izdatnice-potrosni-materijal',
    component: PregledIzdatnicePotrosnogMaterijalaComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'dostavnice',
    component: DostavnicaComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'otpremnice',
    component: OtpremnicaComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'ispis-plana',
    component: IspisPlanaComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'ostvareni-sati',
    component: OstvareniSatiComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'narucene-kolicine-grupe',
    component: NaruceneKolicineGrupeComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'dokumenti',
    component: DokumentiComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'primke',
    component: PrimkeComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'lot-naljepnice',
    component: LotNaljepniceComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'narudzbe',
    component: NarudzbeComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'uredjaji',
    component: UredjajiComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'signalni-lager-sirovina',
    component: SignalniLagerComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'rokovi-trajanja',
    component: RokovitrajanjaComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'ufe',
    component: UfeComponent,
    canActivate: [ AuthGuardService ]
  },

  {
    path: 'ufa/:vrsta',
    component: UfaComponent,
    canActivate: [ AuthGuardService ]
  },

  {
    path: 'ufa/:vrsta/:status',
    component: UfaComponent,
    canActivate: [ AuthGuardService ]
  },

  {
    path: 'digitalna_ploca',
    component: DigitalnaPlocaComponent,
    canActivate: [ AuthGuardService ]
  },

  {
    path: 'pregled-revers',
    component: PregledReversComponent,
    canActivate: [ AuthGuardService ]
  },

  {
    path: 'meduskladisnice',
    component: MeduskladisnicaComponent,
    canActivate: [ AuthGuardService ]
  },

  {
    path: 'meduskladisnice_za_mrvice',
    component: MeduskladisnicaMrviceComponent,
    canActivate: [ AuthGuardService ]
  },

  {
    path: 'kartica_artikla',
    component: KarticaArtiklaComponent,
    canActivate: [AuthGuardService],
  },

  {
    path: 'webapp/:idkorisnik/:idfirma/:token/:modul',
    component: WebappComponent,
    //canActivate: [AuthGuardService],
  },

  {
    path: '',
    redirectTo: 'nadzorna-ploca',
    pathMatch: 'full',
    canActivate: [AuthGuardService],
  },

  // {
  //   path: '**',
  //   redirectTo: 'nadzorna-ploca',
  //   //canActivate: [AuthGuardService],
  // },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true }),
    DxDataGridModule,
    DxFormModule,
    DxSelectBoxModule,
    CommonModule,
    DxDateBoxModule,
    DxButtonModule,
    DxPopupModule,
    DxTextBoxModule,
    DxTextAreaModule,
    DxSelectBoxModule,
  ],
  providers: [AuthGuardService],
  exports: [RouterModule],
  declarations: [NadzornaPlocaComponent],
})
export class AppRoutingModule {}
